import './SectionHeader.css';

export default function SectionHeader({
  eyebrow,
  title,
  titleEm,
  titleRender,
  right,
  className = '',
}) {
  return (
    <div className={`section-header${className ? ` ${className}` : ''}`}>
      <div className="section-header__left">
        {eyebrow && <p className="eyebrow">{eyebrow}</p>}
        {titleRender ? (
          <h2 className="section-title">{titleRender}</h2>
        ) : (
          <h2 className="section-title">
            {title}
            {titleEm && <em> {titleEm}</em>}
          </h2>
        )}
      </div>
      {right && <div className="section-header__right">{right}</div>}
    </div>
  );
}
